import { render, staticRenderFns } from "./DocumentTemplateDropDownList.vue?vue&type=template&id=35b957b5"
import script from "./DocumentTemplateDropDownList.vue?vue&type=script&lang=js"
export * from "./DocumentTemplateDropDownList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports